module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Custom Clearance Export")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.CC_EDI == '0' ? true : false,
      "variant": _vm.CC_EDI == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('EDI')
      }
    }
  }, [_vm._v("EDI Execution")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.CC_BL == '0' ? true : false,
      "variant": _vm.CC_BL == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('BL')
      }
    }
  }, [_vm._v("B/L")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.CC_PAY == '0' ? true : false,
      "variant": _vm.CC_PAY == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('PAY')
      }
    }
  }, [_vm._v("Payment")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.CC_HAND == '0' ? true : false,
      "variant": _vm.CC_HAND == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('HAND')
      }
    }
  }, [_vm._v("Handover")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.CC_VGM == '0' ? true : false,
      "variant": _vm.CC_VGM == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('VGM')
      }
    }
  }, [_vm._v("VGM")])], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "shipmentType"
    }
  }, [_vm._v("CC Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ccInhouseList,
      "isDisabled": "",
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Shipment Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.ccInhouse),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "ccInhouse", $$v)
      },
      expression: "ffExoprtDetail.ccInhouse"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerInfo"
    }
  }, [_vm._v("FF Activity *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.containerInfoList,
      "option-value": "containerInfoVal",
      "option-text": "containerInfoText",
      "placeholder": "Select Activity"
    },
    model: {
      value: (_vm.ffExoprtDetail.containerInfo),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerInfo", $$v)
      },
      expression: "ffExoprtDetail.containerInfo"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.containerInfo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.containerInfo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("Forwarder Name *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "forwarderName",
      "name": "forwarderName"
    },
    model: {
      value: (_vm.ffExoprtDetail.forwarderName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "forwarderName", $$v)
      },
      expression: "ffExoprtDetail.forwarderName"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.forwarderName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.forwarderName))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ffExoprtDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "shippingId", $$v)
      },
      expression: "ffExoprtDetail.shippingId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.shippingId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "exporterClientId", $$v)
      },
      expression: "ffExoprtDetail.exporterClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.exporterClientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.ffExoprtDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "importerClientId", $$v)
      },
      expression: "ffExoprtDetail.importerClientId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.importerClientId))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.openExpoInput == true) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "otherExpoName",
      "name": "otherExpoName"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherImpoName),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherImpoName", $$v)
      },
      expression: "ffExoprtDetail.otherImpoName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerSealed"
    }
  }, [_vm._v("Stuffing Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerSealedList,
      "option-value": "containerSealedV",
      "option-text": "containerSealedT",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.ffExoprtDetail.containerSealed),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "containerSealed", $$v)
      },
      expression: "ffExoprtDetail.containerSealed"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.containerSealed) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.containerSealed))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.ffExoprtDetail.containerInfo == "lcl" ?
    "Measurement(L x B x H)cm/inch" :
    "Gross Wgt"))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "Measurement",
      "name": "Measurement"
    },
    model: {
      value: (_vm.ffExoprtDetail.measurement),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "measurement", $$v)
      },
      expression: "ffExoprtDetail.measurement"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.ffExoprtDetail.containerInfo == "lcl" ? "CBM" : "Net Wgt"))]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "CBM",
      "name": "CBM"
    },
    model: {
      value: (_vm.ffExoprtDetail.CBM),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "CBM", $$v)
      },
      expression: "ffExoprtDetail.CBM"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("No. Of Packages")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "noOfPackage",
      "name": "noOfPackage"
    },
    model: {
      value: (_vm.ffExoprtDetail.noOfPackage),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "noOfPackage", $$v)
      },
      expression: "ffExoprtDetail.noOfPackage"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PORlocationId", $$v)
      },
      expression: "ffExoprtDetail.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PORlocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Load Port Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Air_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Air_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "LPlocationId", $$v)
      },
      expression: "ffExoprtDetail.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.LPlocationId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.getPortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select POD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList(
          $event,
          'Sea_Port,Air_Port',
          'getPortDischargeList'
        )
      },
      "searchchange": function($event) {
        _vm.getLocationList(
          $event,
          'Sea_Port,Air_Port',
          'getPortDischargeList'
        )
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "PODLocationId", $$v)
      },
      expression: "ffExoprtDetail.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.PODLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "finalPlaceLocationId"
    }
  }, [_vm._v("Final Place of Delivery *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select FPOD"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.finalPlaceLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "finalPlaceLocationId", $$v)
      },
      expression: "ffExoprtDetail.finalPlaceLocationId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.finalPlaceLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.finalPlaceLocationId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "pdaDetail"
    }
  }, [_vm._v("PDA Details *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pdaDetailList,
      "option-value": "pdaDetailsVal",
      "option-text": "pdaDetailsText",
      "placeholder": "Select PDA "
    },
    model: {
      value: (_vm.ffExoprtDetail.pdaDetail),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "pdaDetail", $$v)
      },
      expression: "ffExoprtDetail.pdaDetail"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.pdaDetail) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.pdaDetail))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("Commodity *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityList,
      "option-value": "commodityId",
      "option-text": "itemDescription",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'getCommodityData')
      }
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityId),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityId", $$v)
      },
      expression: "ffExoprtDetail.commodityId"
    }
  }), _vm._v(" "), (!_vm.ffExoprtDetail.commodityId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.ffExporterrorList.commodityId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.ffExoprtDetail.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "commodityType", $$v)
      },
      expression: "ffExoprtDetail.commodityType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Hazardous') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.ffExoprtDetail.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "IMDGClass", $$v)
      },
      expression: "ffExoprtDetail.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.ffExoprtDetail.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "UNNumber", $$v)
      },
      expression: "ffExoprtDetail.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.ffExoprtDetail.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "packingCode", $$v)
      },
      expression: "ffExoprtDetail.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Reefer') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.ffExoprtDetail.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "temperatureRequired", $$v)
      },
      expression: "ffExoprtDetail.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ffExoprtDetail.commodityType == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ffExoprtDetail.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "otherComodity", $$v)
      },
      expression: "ffExoprtDetail.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Additional Task")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.showOtherServiceArray), function(otherServiceNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": otherServiceNameArray.flex
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": otherServiceNameArray.value,
        "name": 'otherServices' + (index + 1),
        "id": 'otherServices' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.otherServiceNameArraySelect(
            otherServiceNameArray.value,
            index
          )
        }
      },
      model: {
        value: (_vm.ffExoprtDetail.otherServices[index]),
        callback: function($$v) {
          _vm.$set(_vm.ffExoprtDetail.otherServices, index, $$v)
        },
        expression: "ffExoprtDetail.otherServices[index]"
      }
    }, [_vm._v(_vm._s(otherServiceNameArray.show))])], 1)
  })), _vm._v(" "), (_vm.showAdd) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specify Additional Task")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "specificAdditionalTask",
      "name": "specificAdditionalTask"
    },
    model: {
      value: (_vm.ffExoprtDetail.specificAdditionalTask),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "specificAdditionalTask", $$v)
      },
      expression: "ffExoprtDetail.specificAdditionalTask"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.specialInstruction != null && _vm.specialInstruction != '') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Special Instruction")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.specialInstruction),
      callback: function($$v) {
        _vm.specialInstruction = $$v
      },
      expression: "specialInstruction"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('div', [(_vm.showConDiv == true) ? _c('b-card', [(_vm.showConDiv == true) ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1)]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), (
    _vm.blRegexError == '' &&
    _vm.containerModal.containerNo != '' &&
    _vm.containerModal.containerNo != _vm.algoConNo &&
    _vm.showAlgo == true
  ) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Note:System Generated Container No. is :\n                        " + _vm._s(_vm.algoConNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Container Type/Size *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.ContainerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type/Size"
    },
    model: {
      value: (_vm.containerModal.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerTypeId", $$v)
      },
      expression: "containerModal.containerTypeId"
    }
  }), _vm._v(" "), (!_vm.containerModal.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containererrorList.containerTypeId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Containers No. *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "containerNo",
      "name": "containerNo"
    },
    on: {
      "input": _vm.containerNoRegexfun
    },
    model: {
      value: (_vm.containerModal.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerNo", $$v)
      },
      expression: "containerModal.containerNo"
    }
  })], 1), _vm._v(" "), (!_vm.containerModal.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containererrorList.containerNo))]) : (_vm.blRegexError != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blRegexError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "containerBookingNo",
      "name": "containerBookingNo"
    },
    model: {
      value: (_vm.containerModal.containerSealNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerSealNo", $$v)
      },
      expression: "containerModal.containerSealNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "customSeal",
      "name": "customSeal"
    },
    model: {
      value: (_vm.containerModal.customSeal),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "customSeal", $$v)
      },
      expression: "containerModal.customSeal"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "customSeal",
      "name": "customSeal"
    },
    model: {
      value: (_vm.containerModal.grossWgt),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "grossWgt", $$v)
      },
      expression: "containerModal.grossWgt"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Net Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "customSeal",
      "name": "customSeal"
    },
    model: {
      value: (_vm.containerModal.netWgt),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "netWgt", $$v)
      },
      expression: "containerModal.netWgt"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Package")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.packageNameList,
      "id": "clientId",
      "option-value": "packageId",
      "option-text": "packageName",
      "placeholder": "Select  Package Name"
    },
    model: {
      value: (_vm.containerModal.packageId),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "packageId", $$v)
      },
      expression: "containerModal.packageId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pkg Quantity")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "customSeal",
      "name": "customSeal"
    },
    model: {
      value: (_vm.containerModal.quantity),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "quantity", $$v)
      },
      expression: "containerModal.quantity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "containerBookingNo",
      "name": "containerBookingNo"
    },
    model: {
      value: (_vm.containerModal.containerBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "containerBookingNo", $$v)
      },
      expression: "containerModal.containerBookingNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "md-flex": "5"
    }
  }, [_c('b-button', {
    attrs: {
      "Disabled": _vm.ExecutionDisable == '' ? false : true,
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoaderCon"
    },
    on: {
      "click": function($event) {
        _vm.addCCExport('')
      }
    }
  }, [_vm._v(_vm._s(_vm.containerModal.ccContanerId == "" ? "add" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderCon"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": _vm.addSameDateRadio
    },
    model: {
      value: (_vm.containerModal.allSame),
      callback: function($$v) {
        _vm.$set(_vm.containerModal, "allSame", $$v)
      },
      expression: "containerModal.allSame"
    }
  }, [_vm._v("Booking No Same for all")])], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.containerArray.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [_c('h5', [_c('b-badge', [_vm._v("Container Details")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Booking Documents")])], 1)]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "FreghtContaner"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Container No.")]), _vm._v(" "), _c('th', [_vm._v("Container Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Custom Seal No.")]), _vm._v(" "), _c('th', [_vm._v("Gross Wgt")]), _vm._v(" "), _c('th', [_vm._v("Net Wgt")]), _vm._v(" "), _c('th', [_vm._v("Package")]), _vm._v(" "), _c('th', [_vm._v("Pkg Quantity")]), _vm._v(" "), _c('th', [_vm._v("Booking No.")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.containerArray), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.containerSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.customSeal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.grossWgt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.netWgt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.packageName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.containerBookingNo))]), _vm._v(" "), _c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "outline-success"
      },
      on: {
        "click": function($event) {
          _vm.editContainer(item1)
        }
      }
    }, [_vm._v("Edit")])], 1)])
  }))])])]) : _vm._e()], 1)]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ffExoprtDetail.remark),
      callback: function($$v) {
        _vm.$set(_vm.ffExoprtDetail, "remark", $$v)
      },
      expression: "ffExoprtDetail.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(
    _vm.containerCheck == true || _vm.ffExoprtDetail.splitCCAssign == '1'
  ) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderLast"
    },
    on: {
      "click": function($event) {
        _vm.addCCExport('0')
      }
    }
  }, [_vm._v("Save & Submit")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [(_vm.containerCheck == true) ? _c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderLast"
    },
    on: {
      "click": function($event) {
        _vm.addCCExport('qqqqq')
      }
    }
  }, [_vm._v("Save & Proceed to Edi Execution")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAddSeaImp
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "message",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c760ce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/CCExportEntry.vue
// module id = 2462
// module chunks = 0